import React from 'react';
import VerifyEmail from '@jumbo/components/Common/authComponents/VerifyEmail';

const ConfirmVerifyEmail = () => <VerifyEmail variant="standard" wrapperVariant="bgColor" />;

export default ConfirmVerifyEmail;
